import {Link} from 'react-router-dom';
import './Memory.css';
import numbers from '../../res/numbers.png';
import colors from '../../res/colors.png';
import animals from '../../res/animals.png';

export default function Memory () {
    return (
        <section className='memory_home_section'>
            <h1 className='memory_game_title'>Memory</h1>
            <div className='memory_choices'>
                <Link to ='/memory-chiffres'> <img src ={numbers} className='pic_memory'/> </Link> 
                <Link to ='/memory-couleurs'> <img  src= {colors} className='pic_memory'/> </Link>
                <Link to ='/memory-animaux'> <img  src= {animals} className='pic_memory'/> </Link>
            </div>
        </section>
    );
}